import {
  FolderOutlined,
  SettingsOutlined,
  ExitToApp,
  AccountCircleOutlined,
} from "@mui/icons-material";

export const menuList = [
  {
    label: "Workspace",
    menus: [
      { label: "Scenarios", route: "/projects", icon: <FolderOutlined /> },
      {
        label: "Organisation",
        route: "/settings",
        icon: <SettingsOutlined />,
      },
    ],
  },
  {
    label: "Profile",
    menus: [
      {
        label: "My Profile",
        route: "/profile",
        icon: <AccountCircleOutlined />,
      },
      { label: "Logout", route: "/logout", icon: <ExitToApp /> },
    ],
  },
];
